module.exports = __webpack_public_path__ + "static/07_PLATOS-TUN-CUSCUS-D.4dc9b4ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/07_PLATOS-TUN-CUSCUS-D.png
// module id = 650
// module chunks = 35783957827783